 <template>
    <div class="lang-switcher">
        <button @click="toggleDropdown" class="lang-current">
             <span :class="['fi', 'fi-' + currentLangCode]"></span>
            <span class="lang-code">{{ currentLang.toUpperCase() }}</span>
            <ion-icon name="chevron-down-outline" :class="{ 'rotated': isOpen }"></ion-icon>
        </button>
        
        <div v-if="isOpen" class="lang-dropdown">
            <div 
                v-for="lang in languages" 
                :key="lang.code"
                @click="switchLanguage(lang.code)"
                class="lang-option"
                :class="{ active: currentLang === lang.code }"
            >
                <span :class="['fi', 'fi-' + lang.flagCode]"></span>
                <span class="lang-name">{{ lang.name }}</span>
                <span class="lang-code">{{ lang.code.toUpperCase() }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LanguageSwitcher',
    data() {
        return {
            isOpen: false,
            languages: [
                { code: 'es', flagCode: 'es', name: 'Español' },
                { code: 'en', flagCode: 'gb', name: 'English' },
                { code: 'zh', flagCode: 'cn', name: '中文' },
                { code: 'de', flagCode: 'de', name: 'Deutsch' },
                { code: 'fr', flagCode: 'fr', name: 'Français' },
                { code: 'ar', flagCode: 'sa', name: 'العربية' }
            ]
        }
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        },
         currentLangCode() {
            const lang = this.languages.find(l => l.code === this.currentLang)
            return lang ? lang.flagCode : 'es'
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen
        },
        switchLanguage(lang) {
            if (this.currentLang === lang) {
                this.isOpen = false
                return
            }
            
            // Mantener la ruta actual pero cambiar el idioma
            const pathWithoutLang = this.$route.path.replace(/^\/[a-z]{2}/, '') || ''
            this.$router.push(`/${lang}${pathWithoutLang}`)
            this.isOpen = false
        },
        getFlag(langCode) {
            const lang = this.languages.find(l => l.code === langCode)
            return lang ? lang.flag : '🌐'
        },
        handleClickOutside(event) {
            const el = this.$el
            if (el && !el.contains(event.target)) {
                this.isOpen = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    }
}
</script>

<style scoped>
.lang-switcher {
    position: relative;
    display: inline-block;
}

.lang-current {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    color: #333;
    transition: all 0.2s;
    background: white;
}

.lang-current:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
}

.lang-current ion-icon {
    font-size: 0.9rem;
    transition: transform 0.2s;
}

.lang-current ion-icon.rotated {
    transform: rotate(180deg);
}

.lang-flag {
    font-size: 1.1rem;
    line-height: 1;
}

.lang-code {
    font-weight: 600;
    font-size: 0.75rem;
    color: #666;
}

.lang-dropdown {
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    background: white;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
    min-width: 180px;
    z-index: 1000;
    overflow: hidden;
    animation: slideDown 0.2s ease;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.lang-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    cursor: pointer;
    transition: background 0.15s;
}

.lang-option:hover {
    background: #f1f3f5;
}

.lang-option.active {
    background: #e8f0fe;
}

.lang-option .lang-name {
    flex: 1;
    font-size: 0.85rem;
    color: #333;
}

.lang-option .lang-code {
    font-size: 0.7rem;
    color: #999;
}

.lang-option.active .lang-code {
    color: #1C4A8D;
}

.lang-option .lang-flag {
    font-size: 1.2rem;
}

@media (max-width: 750px) {
    .lang-current .lang-code {
        display: none;
    }
    .lang-dropdown {
        position: relative;
        min-width: 150px;
        right: -10px;
    }
    .lang-option .lang-name {
        font-size: 0.8rem;
    }
}
.fi{
    font-size: 1.2em;
    line-height: 1;
}
.lang-option .fi{
    font-size: 1.2em;
}
</style>